import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SponsorRevenueRow {
  sponsor_id: number | null;
  sponsor_name: string;
  sponsor_email: string | null;
  lic_revenue: number;
  card_revenue: number;
  topup_revenue: number;
  payout_revenue: number;
  total_revenue: number;
}

export interface SponsorRevenueResponse {
  data: SponsorRevenueRow[];
}

export interface LicenseRevenueRow {
  sponsor_id: number | null;
  sponsor_name: string;
  sponsor_email: string | null;
  by_price: Record<string, number>;
  total_revenue: number;
}

export interface LicenseRevenueResponse {
  price_tiers: string[];
  data: LicenseRevenueRow[];
}

@Injectable({ providedIn: 'root' })
export class AdminStatisticsService {
  private http = inject(HttpClient);

  getSponsorRevenue(): Observable<SponsorRevenueResponse> {
    return this.http.get<SponsorRevenueResponse>('/admin/statistics/sponsor_revenue');
  }

  getLicenseRevenue(): Observable<LicenseRevenueResponse> {
    return this.http.get<LicenseRevenueResponse>('/admin/statistics/license_revenue');
  }

  getCardRevenue(): Observable<LicenseRevenueResponse> {
    return this.http.get<LicenseRevenueResponse>('/admin/statistics/card_revenue');
  }
}
